import { useSelector } from "react-redux";
import { DataExportGridTypes } from "../administration/export-data-administration/insExportDataAdministration";
import { DatapointsEntityType, DatapointFilterOperatorEnum, DatapointIdStandardEnum } from "api/ux/src";
import { addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { useCustomDataDatapointsRequest, useGetCustomDataDatapoints } from "hooks/use-custom-data-datapoints";
import { getMeasuresAndDimensionsWithCurrency, getMeasuresAndDimensionsWithoutCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointFields } from "hooks/widget-data/use-datapoints";
import { gridCurrencySelector } from "store/grids";
const usePortfolioDimensions = () => {
    const currency = useSelector((s) => gridCurrencySelector(s, DataExportGridTypes.Portfolio));
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Portfolio]);
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioPortfolioName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioType }, name: "PortfolioType" },
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioAladdinTicker }, name: "Ticker" },
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioCurrency }, name: "Currency" },
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioKind }, name: "PortfolioKind" },
        { datapoint: { standard: DatapointIdStandardEnum.PortfolioAdministrativeSubType }, name: "AdministrativeSubType" }
    ];
    addCustomFieldsAsDatapoints(customFields, datapoints);
    const { dimensions: baseDimensions, measures } = currency
        ? getMeasuresAndDimensionsWithCurrency([], datapoints)
        : getMeasuresAndDimensionsWithoutCurrency(datapoints);
    const dimensions = [...baseDimensions, { datapoint: { standard: DatapointIdStandardEnum.PortfolioPortfolioId }, name: "Id" }];
    const iddFilter = [
        {
            datapoint: { standard: DatapointIdStandardEnum.PortfolioAdministrativeSubType },
            operator: DatapointFilterOperatorEnum.NotIn,
            values: ["InvestmentDueDiligence"]
        }
    ];
    const request = useCustomDataDatapointsRequest(dimensions, measures, DataExportGridTypes.Portfolio, currency, "CustomPortfolioGrid", iddFilter);
    const [data, querystate, refresh] = useGetCustomDataDatapoints(request);
    return {
        customFields,
        data,
        dimensions,
        measures,
        querystate,
        refresh
    };
};
export default usePortfolioDimensions;
